const UPPERCASE_LETTER_PATTERN = /[A-Z]/
const LOWERCASE_LETTER_PATTERN = /[a-z]/
const DECIMAL_DIGIT_PATTERN = /[0-9]/
const SPECIAL_CHARACTER_PATTERN = /[^A-Za-z0-9]/

export type PasswordRuleKey = 'length' | 'upper' | 'lower' | 'digit' | 'special'

export type PasswordChecks = Record<PasswordRuleKey, boolean> & { all: boolean }

export interface PasswordRule {
  key: PasswordRuleKey
  label: string
  test: (password: string) => boolean
}

export const PASSWORD_RULES: PasswordRule[] = [
  { key: 'length', label: 'At least 8 characters', test: (s) => s.length >= 8 },
  { key: 'upper', label: 'An uppercase letter', test: (s) => UPPERCASE_LETTER_PATTERN.test(s) },
  { key: 'lower', label: 'A lowercase letter', test: (s) => LOWERCASE_LETTER_PATTERN.test(s) },
  { key: 'digit', label: 'A number', test: (s) => DECIMAL_DIGIT_PATTERN.test(s) },
  { key: 'special', label: 'A special character', test: (s) => SPECIAL_CHARACTER_PATTERN.test(s) },
]

export function getPasswordChecks(password: string): PasswordChecks {
  const result = {} as Record<PasswordRuleKey, boolean>
  for (const rule of PASSWORD_RULES) {
    result[rule.key] = rule.test(password)
  }
  const all = PASSWORD_RULES.every((rule) => result[rule.key])
  return { ...result, all }
}

export function validatePassword(password: string, confirmPassword: string): string {
  if (!password || !confirmPassword) {
    return 'Both password fields are required'
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match'
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters'
  }
  if (!UPPERCASE_LETTER_PATTERN.test(password)) {
    return 'Password must contain an uppercase letter'
  }
  if (!LOWERCASE_LETTER_PATTERN.test(password)) {
    return 'Password must contain a lowercase letter'
  }
  if (!DECIMAL_DIGIT_PATTERN.test(password)) {
    return 'Password must contain a digit'
  }
  if (!SPECIAL_CHARACTER_PATTERN.test(password)) {
    return 'Password must contain a special character'
  }
  return ''
}
